
import { Component, Vue, Prop } from "vue-property-decorator";

@Component({})
export default class BasicTitle extends Vue {
  @Prop({ type: String, default: "12312313" }) private title!: string;
}
